<template>
    <div class="content-manage">
        <!-- <div class="search-box">
            <span class="text">内容标题</span>
            <input class="input" name="keyword" type="text" placeholder="请输入内容标题" v-model.trim="params.title">
            <span class="text">投稿时间</span>
            <el-date-picker 
                class="date" 
                v-model="dateArr" 
                type="daterange" 
                range-separator="至" 
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            ></el-date-picker>
            <div class="inquire"><input @click="search" type="button" value="查询" class="btn"></div>
        </div> -->
        <div class="list" v-show="list.length">
            <div class="list-item" v-for="(item,index) in list" :key="index" :style="{opacity: item.expire ? .5 : 1}">
                <img :src="item.gameLogo" alt="" class="list-img" style="width: 67px;height:67px;">
                <div class="list-content">
                    <div class="title" @click="toDetail(item)">
                        <a href="javascript:;">{{item.title}}</a>
                    </div>
                    <div class="info">
                        <div>
                            <span class="task-price">{{Number(item.cpa).toFixed(2)}}</span>元
                            <span class="task-tag">CPA</span>

                            <i class="ico ico-time"></i>
                            <span>{{item.startTime}} ~ {{item.endTime}}</span>
                        </div>
                    </div>
                    <div class="btm">
                        <div class="time">{{item.channelDesc}}</div>
                        <div class="action">
                            <div class="copy" @click="handle(item.pageUrl,item,'copy')">
                                <img src="~Assets/img/pages/v4/icon_copy.png" alt="">
                                复制链接
                            </div>
                            <!-- <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                content="移动端即将上线，敬请期待！"> -->
                            <div class="copy" slot="reference" @click="handle(item.pageUrl,item,'showQrCode')">
                                <img src="~Assets/img/pages/v4/icon_sao.png" alt="">
                                移动端二维码
                            </div>
                            <!-- </el-popover> -->

                            <div class="preview" @click="handle(item.pageUrl,item,'preview')">PC预览</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="data-null" v-show="!list.length">
            <img src="~Assets/img/pages/v4/search-null.png" alt="">
        </div>
        <div class="copy-tip" v-show="copyTipVisible" :style="{opacity:copyStyle?1:0}">
            <img src="~Assets/img/pages/v4/copy_success.png" alt="">
            <span>复制成功</span>
            ，现在可以直接粘贴链接地址了。
        </div>
        <div class="qrcode" v-show="qrCodeVisible">
            <div class="title">移动端二维码</div>
            <span class="close" @click="qrCodeVisible=false"></span>
            <div class="info">请使用微信扫描二维码，查看移动端效果</div>
            <div class="code">
                <img :src="codeSrc" alt="">
            </div>
        </div>
        <div class="mask" v-show="qrCodeVisible"></div>
        <el-pagination v-show="total" style="text-align: center;" @current-change="getDownloadTaskJoined()" :current-page.sync="params.page" :page-size="params.pageSize" layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>
<style lang="scss" scoped>
.content-manage {
    margin-top: 10px;
    .date {
        position: relative;
        width: 300px;
        border: none;
        border-bottom: 1px solid rgba(235, 235, 235, 1);
        border-radius: 0;
    }
    .task-price {
        font-size: 20px;
    }
    .task-tag {
        display: inline-block;
        line-height: 20px;
        padding: 0 5px;
        text-align: center;
        font-size: 14px;
        background: #fff2e8;
        color: #fd7e28;
    }
    .ico-time {
        vertical-align: -3px;
        margin-right: 5px;
        margin-left: 60px;
    }
}
</style>

<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/admire/index.scss';
</style>
<script>
import QRCode from 'qrcode';
import {
    DownloadTaskJoined,
    DownloadTaskPage
} from 'Services/getData.js';
export default {
    data() {
        return {
            total: 0,
            params: {
                // title: '',
                // start: '',
                // end: '',
                pageSize: 10,
                page: 1
            },
            dateArr: [],
            qrCodeVisible: false,
            copyTipVisible: false,
            copyStyle: false,
            isCopy: false,
            list: [],
            codeSrc: ''
        };
    },
    mounted() {
        this.getDownloadTaskJoined();
    },
    methods: {
        search() {
            this.params.page = 1;
            this.getDownloadTaskJoined();
        },
        async handle(href, item, type) {
            if (!href) {
                let res = await DownloadTaskPage({
                    id: item.id
                });
                if (res.status === 200 && res.data.code === 0) {
                    if (!res.data.data.url) {
                        this.$alert('链接正在生成中，请2分钟后重试');
                    } else {
                        this.list.forEach(v => {
                            if (v.id == item.id) {
                                v.pageUrl = res.data.data.url;
                            }
                        });
                        this.control(res.data.data.url, item, type);
                    }
                }
            } else {
                this.control(href, item, type);
            }
        },
        control(href, item, type) {
            switch (type) {
            case 'copy':
                this.copy(href);
                break;
            case 'showQrCode':
                this.showQrCode(href);
                break;
            case 'preview':
                this.preview(href);
                break;
            }
        },
        preview(href) {
            window.open(href);
        },
        toDetail(item) {
            this.$router.push({
                name: 'v4-extension-detail',
                query: {
                    userTaskId: item.id,
                    taskId: item.taskId
                }
            });
        },
        async getDownloadTaskJoined() {
            // this.params.start = this.dateArr && this.dateArr[0] || '';
            // this.params.end = this.dateArr && this.dateArr[1] || '';
            let res = await DownloadTaskJoined(this.params);
            if (res.status === 200 && res.data.code === 0) {
                this.list = res.data.data.list;
                this.total = res.data.data.total;
            }
        },
        showQrCode(href) {
            this.qrCodeVisible = true;
            QRCode.toDataURL(href)
                .then(url => {
                    // console.log(url)
                    this.codeSrc = url;
                })
                .catch(err => {
                    // console.error(err)
                    this.codeSrc = '';
                });
        },
        copy(href) {
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.setAttribute('value', href);
            input.select();
            if (document.execCommand('copy')) {
                document.execCommand('copy');
            }
            document.body.removeChild(input);
            this.showCopyTip();
        },
        showCopyTip() {
            if (!this.isCopy) {
                this.isCopy = true;
                this.copyTipVisible = true;
                setTimeout(() => {
                    this.copyStyle = true;
                }, 20);
                setTimeout(() => {
                    this.copyStyle = false;
                    setTimeout(() => {
                        this.copyTipVisible = true;
                        this.isCopy = false;
                    }, 20);
                }, 2000);
            }
        }
    }
}
</script>
